import React from 'react';
import { useSelector } from 'react-redux';
import { Card, CardHeader, CardBody } from 'reactstrap';
import listIcon from "../../../assets/images/list-Item.png";
import Loader from '../../../components/common/Loader';

const InterestsCard = ({ interests }) => {
    const interestLoading = useSelector(state => state.interests.loading);

    return (
        <Card
            style={{
                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                borderRadius: "10px",
                marginLeft: "10px",
            }}
        >
            <CardHeader
                className="justify-content-center d-flex flex-grow-0 border-0"
                style={{
                    paddingBottom: "0px",
                }}
            >
                <h4
                    className="card-title mb-0 px-3 border-bottom"
                    style={{
                        paddingTop: "4px",
                        paddingBottom: "20px",
                    }}
                >
                    <b>Real Life Interests</b>
                </h4>
            </CardHeader>

            {
                interestLoading ? 
                (<CardBody
                style={{
                    minHeight: "355px",
                    padding: 0,
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    width: "100%",
                    display: "flex",  
                    justifyContent: "center",  
                    alignItems: "center"  
                }}
            > 
            <Loader />
            </CardBody>) : 
                 <CardBody
                 style={{
                     minHeight: "355px",
                     padding: 0,
                     paddingLeft: "15px",
                     paddingRight: "15px",
                     width: "100%",
                 }}
             >
                 {
                     <div
                         id="realLifeInterests"
                         className="table-responsive table-card mt-auto h-100"
                         style={{
                             minHeight: "355px",
                             maxHeight: "355px",
                             paddingRight: "15px",
                             paddingLeft: "15px",
                             overflow: "auto",
                         }}
                     >
                         <table className="table table-centered align-middle mt-3">
                             <tbody>
                                 {interests.map((interest, index) => (
                                     <tr key={index}>
                                         <td> <img src={listIcon} alt="" />  &nbsp; {interest.profileName}</td>
                                     </tr>
                                 ))}
                             </tbody>
                         </table>
                     </div>
                 }
             </CardBody>
            }
       
        </Card>
    );
};

export default InterestsCard;
